import { GHubThemeType, GHubThemeVariant } from './ghub-theme.type';
import { PropsWithChildren } from 'react';
import { mapGHubThemeToCXTheme } from './ghub-theme.function';
import { ThemeStylesheetLoader } from './ThemeStylesheetLoader';
import { Provider } from '../../components/atoms/provider/Provider';

type ThemeProps = {
  theme: GHubThemeType;
  variant?: GHubThemeVariant;
};

export const GHubTheme = ({
  theme,
  variant = 'primary',
  children
}: PropsWithChildren<ThemeProps>) => {
  const cxTheme = mapGHubThemeToCXTheme(theme, variant);
  return (
    <Provider theme={cxTheme} manageModalExternally={true} sizeDefault='large'>
      <ThemeStylesheetLoader theme={theme} />
      {children}
    </Provider>
  );
};
